'use client';

import { getFragmentData } from '@/__generated__';
import { BLOCKS_FRAGMENT } from '@/gql/fragments/blocks.gql';
import { MaskedBlockProps } from '@/lib/parsers/blocks';
import { maybeGet, slugify } from '@liquorice/utils';
import { useBlocks } from '../Blocks/useBlocks';
import UnstyledAccordion from '../UnstyledAccordion';

export type AnchorTreeNavigationAccordionProps = {
  index?: number;
  maskedBlock: MaskedBlockProps<unknown>;
};

const AnchorTreeNavigationAccordionItem = ({
  index,
  maskedBlock,
}: AnchorTreeNavigationAccordionProps) => {
  const blocks = getFragmentData(BLOCKS_FRAGMENT, maskedBlock.data);
  const maybeBlockData = useBlocks(blocks);
  const maybeHeading = maybeGet(maybeBlockData, 'heading');

  if (index === undefined) return null;

  const handleClick = () => {
    if (typeof window !== 'undefined' && maybeHeading) {
      window.location.hash = slugify(maybeHeading);
    }
  };

  if (maybeHeading) {
    return (
      <UnstyledAccordion.Item index={index}>
        <UnstyledAccordion.ItemHandle
          {...{
            cx: { p: 'xs' },
            justifyContent: 'start',
            columnGap: '4xs',
            align: 'left',
          }}>
          <UnstyledAccordion.ItemLabel
            {...{
              onClick: handleClick,
              cx: { textAlign: 'left' },
              variant: 'text',
              color: 'black',
            }}>
            {maybeHeading}
          </UnstyledAccordion.ItemLabel>
        </UnstyledAccordion.ItemHandle>
      </UnstyledAccordion.Item>
    );
  }
};

export default AnchorTreeNavigationAccordionItem;
